import { createApp } from "vue";
import App from "./App.vue";
import SvgIcon from "@/components/SvgIcon.vue";
import router from "./router";
import store from "./store";
import i18n from "./locales";
import "./main.css";

const initApp = async () => {
  const accessToken = localStorage.getItem("accessToken");
  const refreshToken = localStorage.getItem("refreshToken");

  if (accessToken) {
    try {
      store.commit("setState", {
        key: "accessToken",
        value: accessToken,
      });
      store.commit("setState", {
        key: "refreshToken",
        value: refreshToken,
      });

      const user = await store.dispatch("getUserProfile");
      console.log(user);

      store.commit("setState", {
        key: "user",
        value: user,
      });
    } catch (error) {
      console.log("error");
      console.log(error);
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      window.location.reload();
    }
  }

  createApp(App)
    .use(store)
    .use(router)
    .use(i18n)
    .component("SvgIcon", SvgIcon)
    .mount("#app");
};

initApp();
